import React from 'react';
import CTProduct from './CTProduct';
import CTSection from './CTSection';
import useNeuroState from '../../state';
import { ConversationTestModulePropTypes } from '../../utils';

const CTProductsRecommended = ({
  enableProductDetails,
  enableProductIds,
  enableMatchedRules,
  enableCalculations,
  isFullHeight,
  width,
}) => {
  const { testPageData = {} } = useNeuroState();
  const { products } = testPageData;
  const matchedProducts = (products || []).map((product) => {
    return (
      <CTProduct
        product={product}
        key={product.id}
        enableProductIds={enableProductIds}
        enableProductDetails={enableProductDetails}
        enableMatchedRules={enableMatchedRules}
        enableCalculations={enableCalculations}
      />
    );
  });

  return (
    <CTSection
      isFullHeight={isFullHeight}
      className="matched-products"
      title="Recommended Products"
      titleContent={
        <span className="card-title-helper">
          {(products || []).length} Matched
        </span>
      }
      width={width}
    >
      {matchedProducts}
    </CTSection>
  );
};

CTProductsRecommended.propTypes = {
  ...ConversationTestModulePropTypes,
};
export default CTProductsRecommended;
